import React from 'react';

const Error = (props) => {
  return (
    <div class='col-xs-12 col-sm-8 col-sm-offset-2 animated-d1s fadeIn mar40'>
      <div class='alert alert-danger col-md-12 center'>
        {props.msg}
      </div>
    </div>
  );
};
export default Error;
